import { ArbitroMovilidad, ArbitroMovilidadJSON } from '../ArbitroMovilidad/ArbitroMovilidad';

export interface ArbitroXArbitroMovilidadJSON {
  axam_id: string | null;
  axam_arbid: string;
  axam_arbmid: string;
  arbitroMovilidad: ArbitroMovilidadJSON;
  __delete: boolean;
}

export class ArbitroXArbitroMovilidad {
  protected constructor(
    private id: string | null,
    private arbid: string,
    private arbmid: string,
    private arbitroMovilidad: ArbitroMovilidad,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    arbid: string,
    arbmid: string,
    arbitroMovilidad: ArbitroMovilidad,
    __delete: boolean
  ) {
    return new this(id, arbid, arbmid, arbitroMovilidad, __delete);
  }

  arbitroMovilidadIs(am: ArbitroMovilidad): boolean {
    return am.isIdentifiedBy(String(this.arbmid));
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: ArbitroXArbitroMovilidad) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroXArbitroMovilidadJSON) {
    return ArbitroXArbitroMovilidad.createFrom(
      entity.axam_id,
      entity.axam_arbid,
      entity.axam_arbmid,
      ArbitroMovilidad.fromJSON(entity.arbitroMovilidad),
      entity.__delete
    );
  }

  toJSON(): ArbitroXArbitroMovilidadJSON {
    return {
      axam_id: this.getId(),
      axam_arbid: this.getArbid(),
      axam_arbmid: this.getArbmid(),
      arbitroMovilidad: this.getArbitroMovilidad().toJSON(),
      __delete: this.get__delete(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getArbid(): string {
    return this.arbid;
  }

  getArbmid(): string {
    return this.arbmid;
  }

  getArbitroMovilidad(): ArbitroMovilidad {
    return this.arbitroMovilidad;
  }

  get__delete(): boolean {
    return this.__delete;
  }
  setId(value: string | null): void {
    this.id = value;
  }

  setArbid(value: string): void {
    this.arbid = value;
  }

  setArbmid(value: string): void {
    this.arbmid = value;
  }

  setArbitroMovilidad(value: ArbitroMovilidad): void {
    this.arbitroMovilidad = value;
  }

  set__delete(value: boolean): void {
    this.__delete = value;
  }
}
